import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setProduct2skill2exp2rateSorting} from 'store/slice/ManufSlice';

export default function Product2skill2exp2rateListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.product2skill2exp2rateDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setProduct2skill2exp2rateSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
        <Grid item lg={4} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('workername')}> Worker  </Typography></Grid>
        <Grid item lg={4} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('productname')}> Product  </Typography></Grid>
    
        <Grid item lg={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('rate')}> Rate </Typography></Grid>
                        

      </Grid>
      
    )
}